import { GuestSubscriptionFormErrorJSON } from '../models/guest-subscription-form';

export const formGuestSubscriptionErrors: GuestSubscriptionFormErrorJSON = {
    awb: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
